import { THEME_ID, ThemeDefinition } from './types';

export const kindlyChristianTheme: ThemeDefinition = {
  id: THEME_ID.KINDLY_CHRISTIAN,
  name: 'Kindly Christian',
  colors: {
    'footer-bg': '0, 104, 127' /* #00687F */,
    'button-primary': '0, 104, 127' /* #00687F */,
    'button-primary-hover': '0, 70, 86' /* #004656 */,
    'button-secondary': '243, 243, 250' /* #f3f3fa */,
    'button-secondary-hover': '233, 233, 242' /* #e9e9f2 */,
    'peer-details-bg': '0, 104, 127' /* #00687F */,
    primary: '0, 104, 127' /* #00687F */,
    'primary-dark': '0, 70, 86' /* #004656 */,
    'profile-circle': '0, 104, 127' /* #00687F */,
    'profile-circle-hover': '0, 70, 86' /* #004656 */,
    'profile-gradient-start': '0, 104, 127' /* #00687F */,
    'profile-gradient-end': '0, 104, 127' /* #00687F */,
    'connect-bg': '227, 238, 241' /* #E3EEF1 */,
    'connect-bg-hover': '207, 227, 235' /* #CFE3EB */,
    'see-more': '180, 217, 214' /* #B4D9D6 */,
    'see-more-hover': '153, 204, 201' /* #99CCC9 */,
    pill: '180, 217, 214' /* #B4D9D6 */,
    accent: '255, 129, 91' /* #ff815b */,
    'arrow-disabled': '179, 179, 179' /* #B3B3B3 */,
    black: '0, 0, 0',
    white: '255, 255, 255',
    'gray-light': '245, 245, 245' /* #F5F5F5 */,
    'progress-bar-gray': '217, 217, 217' /* #d9d9d9 */,
    'input-border-gray': '229, 231, 235' /* #e5e7eb */,
    'placeholder-gray': '106, 114, 130' /* #6a7282 */,
    'muted-text-gray': '94, 94, 121' /* #5e5e79 */,
    'body-gray': '74, 85, 101' /* #4A5565 */,
    'label-gray': '16, 24, 40' /* #101828 */,
    'avatar-border-slate': '202, 213, 226' /* #CAD5E2 */,
    'section-header-slate': '98, 116, 142' /* #62748E */,
    'icon-slate': '144, 161, 185' /* #90A1B9 */,
    'link-light': '207, 225, 255' /* #CFE1FF */,
    error: '199, 0, 54' /* #c70036 */,
    /* Status / UI */
    success: '0, 201, 80' /* #00c950 */,
    'success-hover': '0, 184, 72' /* #00b848 */,
    unavailable: '203, 203, 203' /* #cbcbcb */,
    'selected-border': '0, 78, 203' /* #004ecb */,
    'selected-bg': '240, 244, 255' /* #f0f4ff */,
    'accent-hover': '226, 107, 71' /* #e66b47 */,
    /* Landing */
    'landing-cream': '247, 241, 232' /* #F7F1E8 */,
    'landing-off-white': '253, 249, 243' /* #FDF9F3 */,
    'landing-border': '238, 235, 231' /* #EEEBE7 */,
    'slate-hover': '87, 97, 118' /* #576176 */,
    /* Connect by Goal topic cards */
    'topic-card-divider': '127, 201, 196' /* #7FC9C4 - underline */,
    'topic-card-icon-1': '133, 173, 170' /* #85ADAA */,
    'topic-card-icon-2': '188, 215, 207' /* #BCD7CF */,
  },
};
